export const typesPauses = {
	createPause: 0,
	createPauseRange: 1,
	editPause: 2,
	reactivePause: 3,
	deletePause: 4,
};
